@if (showProductTitle) {
<div class="flex-grow-1 overflow-hidden d-flex flex-column">
  @if (titlePrefixFields.length > 0) {
  <atx-concatenated-object-fields
    class="title-prefix text-truncate"
    [sourceObject]="product"
    [sourceFields]="titlePrefixFields"
  ></atx-concatenated-object-fields>
  }
  <atx-product-card-title
    class="w-100 mb-0"
    [product]="product"
    [titleFields]="titleFields"
  ></atx-product-card-title>
</div>
}

<div class="d-flex items-center" [ngClass]="{ 'pt-1': !showProductTitle }">
  @if (!compactView) {
  <div class="flex-grow-1 overflow-hidden">
    <atx-product-card-style-id
      [product]="product"
      [idFields]="idFields"
    ></atx-product-card-style-id>
  </div>
  }

  <atx-product-prices
    [prices]="price"
    [showWholeSalePrices]="!showMarkup && showWholeSalePrice"
    [showMarkup]="showMarkup && showWholeSalePrice"
    [isSearchV2Enabled]="isSearchV2Enabled"
  ></atx-product-prices>
</div>
